<div class="container">
    <mat-accordion>
        <mat-expansion-panel *ngFor="let form of userForms; let i = index" [expanded]="false">
            <!-- Panel header to contain user's name -->
            <mat-expansion-panel-header>
                <mat-panel-title>
                    {{ form.get('name')?.value || 'Unnamed User' }}
                </mat-panel-title>

                <div class="panel-actions">
                    <button mat-raised-button color="primary" (click)="assignGroup(form)" aria-label="Add Permission Group">Add Permission Group</button>
                </div>
            </mat-expansion-panel-header>

            <!-- Panel Form for editing permissions -->
            <form [formGroup]="form" class="user-form">

                <!-- Array of permissions -->
                <div formArrayName="permissions" class="permissions-list">
                    <div *ngFor="let permissionControl of getPermissionsArray(form).controls; let j = index" class="permission-item">

                        <mat-form-field appearance="fill" class="permission-field">
                            <mat-label>Permission</mat-label>
                            <mat-select [formControlName]="j">
                                <mat-option *ngFor="let option of getPermissionOptionsForSelect(form, j)" [value]="option">
                                    {{ option }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>

                        <button mat-fab color="warn" (click)="removePermission(form, j)" aria-label="Remove Permission">
                            <mat-icon>remove</mat-icon>
                        </button>
                    </div>
                </div>

                <!-- Action Buttons -->
                <div class="action-buttons">
                    <button mat-flat-button color="primary" (click)="addPermission(form)" aria-label="Add Permission" 
                            [disabled]="hasAllPermissions(form)">
                        <mat-icon>add</mat-icon>
                    </button>

                    <button mat-flat-button color="primary" (click)="saveUser(form)">Save</button>
                </div>
            </form>
        </mat-expansion-panel>
    </mat-accordion>
</div>